import React from 'react';
import './App.css';
import { Editor } from "./editor";

const App: React.FC = () => {
    return (
        <div className="App">
            <Editor />
        </div>
    );
};

export default App;
